function $6a68382a7fd0fba9$export$e16d8520af44a096(a, b) {
    return a + b;
}
function $6a68382a7fd0fba9$export$4e2d2ead65e5f7e3(a, b) {
    return a - b;
}
function $6a68382a7fd0fba9$export$2060d2db72cce88f(a, b) {
    return a * b;
}
function $6a68382a7fd0fba9$export$cd007d971a5a2143(a, b) {
    return a / b;
}



const $9902d383b4dddabd$var$output = document.querySelector(".calculator__result");
const $9902d383b4dddabd$var$clear = document.querySelector(".clear");
const $9902d383b4dddabd$var$equals = document.querySelector(".equals");
const $9902d383b4dddabd$var$operators = document.querySelectorAll(".operator");
const $9902d383b4dddabd$var$numbers = document.querySelectorAll(".number");
const $9902d383b4dddabd$var$outputs = document.querySelectorAll(".calculator__output");
const $9902d383b4dddabd$var$change = document.querySelector(".changeSign");
$9902d383b4dddabd$var$operators.forEach((operator)=>operator.addEventListener("click", (event)=>{
        $9902d383b4dddabd$var$outputs[1].textContent = event.target.textContent;
    }));
$9902d383b4dddabd$var$change.addEventListener("click", (event)=>{
    if ($9902d383b4dddabd$var$outputs[1].textContent !== "" && $9902d383b4dddabd$var$outputs[2].textContent !== "") $9902d383b4dddabd$var$outputs[2].textContent = Number($9902d383b4dddabd$var$outputs[2].textContent) * -1;
    else if ($9902d383b4dddabd$var$outputs[0].textContent !== "") $9902d383b4dddabd$var$outputs[0].textContent = Number($9902d383b4dddabd$var$outputs[0].textContent) * -1;
});
$9902d383b4dddabd$var$numbers.forEach((number)=>number.addEventListener("click", (event)=>{
        if ($9902d383b4dddabd$var$outputs[1].textContent === "") $9902d383b4dddabd$var$outputs[0].textContent += event.target.textContent;
        else $9902d383b4dddabd$var$outputs[2].textContent += event.target.textContent;
    }));
$9902d383b4dddabd$var$clear.addEventListener("click", (event)=>{
    $9902d383b4dddabd$var$outputs.forEach((output)=>{
        output.textContent = "";
    });
    $9902d383b4dddabd$var$output.textContent = "";
});
$9902d383b4dddabd$var$equals.addEventListener("click", (event)=>{
    if ($9902d383b4dddabd$var$outputs[0].textContent !== "" && $9902d383b4dddabd$var$outputs[1].textContent !== "" && $9902d383b4dddabd$var$outputs[2].textContent !== "") {
        const first = Number($9902d383b4dddabd$var$outputs[0].textContent);
        const action = $9902d383b4dddabd$var$outputs[1].textContent;
        const second = Number($9902d383b4dddabd$var$outputs[2].textContent);
        if (action === "+") $9902d383b4dddabd$var$output.textContent = (0, $6a68382a7fd0fba9$export$e16d8520af44a096)(first, second);
        else if (action === "-") $9902d383b4dddabd$var$output.textContent = (0, $6a68382a7fd0fba9$export$4e2d2ead65e5f7e3)(first, second);
        else if (action === "\xd7") $9902d383b4dddabd$var$output.textContent = (0, $6a68382a7fd0fba9$export$2060d2db72cce88f)(first, second);
        else $9902d383b4dddabd$var$output.textContent = (0, $6a68382a7fd0fba9$export$cd007d971a5a2143)(first, second);
    }
});




//# sourceMappingURL=Calculator.f612eaf7.js.map
